import { IsArray } from "../checks/IsArray"

type blobInput = Blob | string | Uint8Array

export const ToBlob = (value: blobInput | blobInput[], type?: string): Blob =>
  new Blob((IsArray(value) ? value : [value]) as unknown as BlobPart[], {
    type,
  })
